<template>
  <div class="google-login">
    <div ref="button"></div>
    <span v-if="loading" role="status">Carregando login com Google...</span>
    <div v-if="error" role="alert">
      <span>Não foi possível carregar o login com Google.</span>
      <button type="button" class="btn btn-link" @click="renderButton">Tentar novamente</button>
    </div>
  </div>
</template>

<script>
let googleClient;
let activeCallback;

function loadGoogleClient() {
  if (googleClient) return googleClient;

  googleClient = new Promise((resolve, reject) => {
    const initialize = () => {
      window.google.accounts.id.initialize({
        client_id: '1005397862007-q171itm6sjnhibgvqb87lmeo9fmf4024.apps.googleusercontent.com',
        ux_mode: 'popup',
        callback: response => activeCallback && activeCallback(response),
      });
      resolve(window.google.accounts.id);
    };

    if (window.google?.accounts?.id) {
      initialize();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = initialize;
    script.onerror = () => {
      script.remove();
      googleClient = null;
      reject(new Error('Não foi possível carregar o SDK do Google.'));
    };
    document.head.appendChild(script);
  });

  return googleClient;
}

export default {
  name: 'BtnLoginGoogle',
  emits: ['onSuccess'],
  data() {
    return { loading: true, error: false };
  },
  mounted() {
    this.renderButton();
  },
  beforeUnmount() {
    if (activeCallback === this.onSuccess) activeCallback = null;
  },
  methods: {
    onSuccess(response) {
      this.$emit('onSuccess', response);
    },
    async renderButton() {
      this.loading = true;
      this.error = false;
      try {
        const client = await loadGoogleClient();
        if (!this.$refs.button) return;

        activeCallback = this.onSuccess;
        client.renderButton(this.$refs.button, {
          type: 'standard',
          theme: 'outline',
          size: 'large',
          text: 'signin_with',
          locale: 'pt-BR',
          click_listener: () => { activeCallback = this.onSuccess; },
        });
      } catch {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.google-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 40px;
}
</style>
